import * as React from 'react';
import Back from "@material-ui/icons/ArrowBack"
import { useHistory } from 'react-router-dom';

const Politicas = () => {
    let history = useHistory();
    return (
        <div className="container-fluid" style={{padding: 0}}>
            <div className="row align-items-center" style={{
                backgroundColor: "040c33",
                height: "2.5rem",
                color: "white",
                margin: 0,
            }}>
                <Back onClick={() => history.goBack()}/>
                <h5 style={{margin: 0}}>POLITICA DE PRIVACIDAD</h5>
            </div>
            <div className="row w-100 m-0 p-2">
                <h5>ESTOY DE ACUERDO EN:</h5>
                <br/>
                <p>
                Que te enviemos información relevante de mercadotecnia, para que no pierdas ofertas y promociones. Normalmente   contactamos  a nuestros clientes por medios electrónicos       incluyendo correo  electrónico o mensajes via celular (SMS).
                </p>
                <br/>
                <p>
                Que analicemos tus preferencias, intereses, y     comportamientos para enviarte  comunicación personalizada que    te pueda interesar.
                </p>
                <br/>
                <p>
                Que compartamos tus datos con compañías y socios selectos    con quienes  trabajamos para enviarte ofertas relevantes.
                </p>
            </div>
        </div>
    )
}

export default Politicas
